module.exports = __webpack_public_path__ + "static/img/8.6e82b387.jpg";